import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import './FitText.scss';

class FitText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fontSize: 16,
            lineHeight: 24,
            maxFontSize: 32,
            minFontSize: this.props.minFontSize,
        };
        this.textContainerRef = null;
        this.longestWordContainerRef = null;
        this.updateFont = debounce(this.updateFont.bind(this), 100);
        this.updateMaxFontSize = this.updateMaxFontSize.bind(this);
    }

    componentDidMount() {
        this.updateMaxFontSize();
        this.updateLongestWord();
        this.updateFont();
        window.addEventListener('resize', this.updateMaxFontSize);
        window.addEventListener('resize', this.updateFont);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateMaxFontSize);
        window.removeEventListener('resize', this.updateFont);
    }

    setTextContainerRef = (ref) => {
        this.textContainerRef = ref;
    };

    setLongestWordContainerRef = (ref) => {
        this.longestWordContainerRef = ref;
    };

    updateMaxFontSize() {
        const container = this.textContainerRef;
        if (!container) return;
    
        const longestWordContainer = this.longestWordContainerRef;
        longestWordContainer.style.fontSize = '';
    
        const computedStyle = window.getComputedStyle(longestWordContainer);
        const fontSize = Math.round(parseFloat(computedStyle.getPropertyValue('font-size')));
    
        this.setState({ maxFontSize: fontSize }, () => {
            this.updateFont();
        });
    }

    updateLongestWord() {
        const longestWordContainer = this.longestWordContainerRef;
        const text = this.props.text;
        const words = text.split(' ');

        let longestWord = '';
        let longestWordWidth = 0;

        words.forEach((word) => {
            longestWordContainer.textContent = word;
            const width = longestWordContainer.offsetWidth;
            if (width > longestWordWidth) {
                longestWordWidth = width;
                longestWord = word;
            }
        });
        this.longestWordContainerRef.textContent = longestWord;
    }

    updateFont() {
        const container = this.textContainerRef;
        const longestWordContainer = this.longestWordContainerRef;
        if (!container || !this.longestWordContainerRef) return;

        container.style.opacity = '0';

        const { maxFontSize, minFontSize } = this.state;
        const computedStyle = window.getComputedStyle(container);
        const fontSize = parseFloat(computedStyle.getPropertyValue('font-size'));

        let currentFontSize = fontSize > maxFontSize ? maxFontSize : fontSize;
        longestWordContainer.style.fontSize = currentFontSize + 'px';
        const maxWidth = container.offsetWidth;

        let longestWordWidth = 0;
        longestWordWidth = longestWordContainer.offsetWidth;

        const { forMobileOnly, mobileBreakpoint } = this.props;
        const screenWidth = window.innerWidth;

        if (forMobileOnly && screenWidth >= mobileBreakpoint) {
            container.removeAttribute('style');
            container.style.opacity = '1';
            return;
        }

        if (longestWordWidth > maxWidth) {
            while (longestWordWidth > maxWidth && currentFontSize > minFontSize) {
                currentFontSize--;
                longestWordContainer.style.fontSize = currentFontSize + 'px';
                longestWordWidth = longestWordContainer.offsetWidth;
            }
        } else {
            while (longestWordWidth < maxWidth && currentFontSize < maxFontSize) {
                currentFontSize++;
                longestWordContainer.style.fontSize = currentFontSize + 'px';
                longestWordWidth = longestWordContainer.offsetWidth;
            }
            currentFontSize--;
        }
        const currentFontSizeRounded = Math.floor(currentFontSize);
        container.style.fontSize = currentFontSizeRounded + 'px';
        const lineHeight = Math.ceil(currentFontSize * 1.5);
        this.setState({ fontSize: currentFontSizeRounded, lineHeight });
        container.style.lineHeight = `${lineHeight}px`;
        container.style.opacity = '1';
    }

    render() {
        const { lineHeight } = this.state;
        return (
            <div className='fit-text'>
                <div className='fit-text__longest-word' aria-hidden='true'>
                    <span className='fit-text__longest-word-container' ref={this.setLongestWordContainerRef}></span>
                </div>
                <div
                    className='fit-text__text'
                    ref={this.setTextContainerRef}
                    style={{ lineHeight: `${lineHeight}px` }}
                >
                    {this.props.text}
                </div>
            </div>
        );
    }
}

FitText.propTypes = {
    text: PropTypes.string.isRequired,
    forMobileOnly: PropTypes.bool,
    mobileBreakpoint: PropTypes.number,
    minFontSize: PropTypes.number,
};

FitText.defaultProps = {
    forMobileOnly: true,
    mobileBreakpoint: 480,
    minFontSize: 12,
};

export default FitText;


// WEBPACK FOOTER //
// ./src/components/FitText/FitText.jsx